import { render, staticRenderFns } from "./fit_industry.vue?vue&type=template&id=52b4fc38&scoped=true"
import script from "./fit_industry.vue?vue&type=script&lang=js"
export * from "./fit_industry.vue?vue&type=script&lang=js"
import style0 from "./fit_industry.vue?vue&type=style&index=0&id=52b4fc38&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b4fc38",
  null
  
)

export default component.exports